<template>
  <div class="hm-card landing blue-header-banner">
    <div class="header-banner">
      <h2>Do You Receive Extra Help?</h2>
      <p>
        If you and/or your spouse already receive Extra Help (LIS – Low Income Subsidy), select “Yes.”
        <span class="tooltip-icon" v-tooltip="'Extra Help (or Low Income Subsidy) is a government program that helps beneficiaries with limited financial resources lower their prescription drug costs.'">
          <img src="//hm-lis.herokuapp.com/img/svg/info-circle-solid.svg" alt="image">
        </span>
      </p>
    </div>
    <div class="max-w white">
      <div class="large-icons-block center" style="margin: 0 auto;">
        <SuiButton basic color="grey" class="large-icon-square" @click="() => onReceiveExtraHelp(true)">
          <span>Yes</span>
          <div class="img check-on"></div>
        </SuiButton>
        <SuiButton basic color="grey" class="large-icon-square" @click="() => onReceiveExtraHelp(false)">
          <span>No</span>
          <div class="img check-off"></div>
        </SuiButton>
      </div>

      <div class="dropdown" v-if="receiveExtraHelp">
        <p>How Much Do You Pay for Covered Prescription Drugs?</p>
        <SuiDropdown
          placeholder="Select One"
          selection
          fluid
          :labeled="true"
          :options="howMuchOptions"
          v-model="howMuch"
        />
      </div>
      
      <div v-if="receiveExtraHelp" style="text-align: center;">
        <SuiButton
          class="next-btn"
          color="green"
          :disabled="isNextDisabled()"
          @click="() => goNextStep('bank-and-investment')">Next</SuiButton>
      </div>
    </div>
  </div>
</template>

<script>
  import ExtraHelp from '@/components/small/ExtraHelp';

  export default {
    extends: ExtraHelp,
  }
</script>

<style lang="scss" scoped>

  .large-icon-square:hover {
    .check-off {
      background-image: url('//hm-lis.herokuapp.com/img/svg/check_off_green.svg');
    }
    .check-on {
      background-image: url('//hm-lis.herokuapp.com/img/svg/check_on_green.svg');
    }
  }
  .check-on {
    background-image: url('//hm-lis.herokuapp.com/img/svg/check_on.svg');
  }
  .check-off {
    background-image: url('//hm-lis.herokuapp.com/img/svg/check_off.svg');
  }

</style>
